import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5127bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bodyFilter d-flex flex-column gap-2" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Grupo", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Lojas", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Eventos", -1))
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Usuarios", -1))
const _hoisted_9 = { key: 3 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "URL", -1))
const _hoisted_11 = { key: 4 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Método", -1))
const _hoisted_13 = { key: 5 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Placa", -1))
const _hoisted_15 = { key: 6 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Headers", -1))
const _hoisted_17 = { key: 7 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Envio", -1))
const _hoisted_19 = { key: 8 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Retorno", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Data", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_FilterBase = _resolveComponent("FilterBase")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "FilterRelatory",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: true,
    onSearch: _cache[11] || (_cache[11] = ($event: any) => (_ctx.enviarEmit()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.typeRelatorio === 1 || _ctx.typeRelatorio === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_el_select, {
                modelValue: _ctx.relatoryFilter.grupo,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.relatoryFilter.grupo) = $event)),
                multiple: "",
                filterable: "",
                "collapse-tags": "",
                placeholder: "Selecione um grupo",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeGroups, (group, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: group.nome,
                      value: group.id,
                      key: key
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _hoisted_4,
          _createVNode(_component_el_select, {
            "collapse-tags": "",
            filterable: "",
            placeholder: "Selecione...",
            clearable: "",
            multiple: "",
            modelValue: _ctx.relatoryFilter.loja,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.relatoryFilter.loja) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojas, (loja, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: loja.nome,
                  value: loja.codConcessionaria
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (_ctx.typeRelatorio === 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_select, {
                "collapse-tags": "",
                filterable: "",
                placeholder: "Selecione...",
                clearable: "",
                multiple: "",
                modelValue: _ctx.relatoryFilter.eventos,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.relatoryFilter.eventos) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: key,
                      label: user.name,
                      value: user.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.typeRelatorio === 1 || _ctx.typeRelatorio === 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_el_select, {
                "collapse-tags": "",
                filterable: "",
                placeholder: "Selecione...",
                clearable: "",
                multiple: "",
                modelValue: _ctx.relatoryFilter.usuarios,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.relatoryFilter.usuarios) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: key,
                      label: user.name,
                      value: user.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.typeRelatorio === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_select, {
                "collapse-tags": "",
                filterable: "",
                placeholder: "Selecione...",
                clearable: "",
                modelValue: _ctx.relatoryFilter.url,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.relatoryFilter.url) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: key,
                      label: user.name,
                      value: user.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.typeRelatorio === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_el_select, {
                "collapse-tags": "",
                filterable: "",
                placeholder: "Selecione...",
                clearable: "",
                multiple: "",
                modelValue: _ctx.relatoryFilter.metodo,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.relatoryFilter.metodo) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, key) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: key,
                      label: user.name,
                      value: user.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.typeRelatorio === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createVNode(_component_el_input, {
                clearable: "",
                modelValue: _ctx.relatoryFilter.placa,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.relatoryFilter.placa) = $event)),
                placeholder: "Digite...",
                maxlength: "8"
              }, null, 8, ["modelValue"]), [
                [_directive_maska, { mask: 'AAA-****', tokens: { '*': { pattern: /[a-zA-Z0-9]/, uppercase: true } },}]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.typeRelatorio === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_el_input, {
                clearable: "",
                modelValue: _ctx.relatoryFilter.headers,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.relatoryFilter.headers) = $event)),
                placeholder: "Digite..."
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.typeRelatorio === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_el_input, {
                clearable: "",
                modelValue: _ctx.relatoryFilter.envio,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.relatoryFilter.envio) = $event)),
                placeholder: "Digite..."
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.typeRelatorio === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_el_input, {
                clearable: "",
                modelValue: _ctx.relatoryFilter.retorno,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.relatoryFilter.retorno) = $event)),
                placeholder: "Digite..."
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _hoisted_21,
          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.relatoryFilter.data,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.relatoryFilter.data) = $event)),
                type: "daterange",
                format: "DD/MM/YYYY",
                class: "w-100",
                style: {"border":"1.5px solid #dbdbdb","border-radius":"4px","height":"36px"},
                "start-placeholder": "inicial",
                "end-placeholder": "final",
                "default-value": [new Date(), new Date()]
              }, null, 8, ["modelValue", "default-value"])
            ]),
            _: 1
          }, 8, ["locale"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}